'use strict';

var chunkGWPDT7BR_js = require('../chunk-GWPDT7BR.js');
require('../chunk-U3QCK4FI.js');
var chunkHUKGHOBJ_js = require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var o = require('react');
var g = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var g__default = /*#__PURE__*/_interopDefault(g);

var S=g__default.default.div`
  color: ${({$color:e})=>e};
  ${({$lineCount:e,$expanded:t,$isExpandable:a})=>a&&!t&&`
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${e};
    -webkit-box-orient: vertical;
  `}
  ${({$isExpandable:e,$expanded:t})=>e&&!t&&"overflow: hidden;"}
  font-size: ${({$size:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
    h2 {
      font-size: ${({$fontSize:e})=>e};
      color: ${({$color:e})=>e};
      padding: ${({$gap:e})=>e} 0px;
      font-weight: ${({$fontWeight:e})=>e};
      line-height: ${({$lineHeight:e})=>e};
      margin: ${({$margin:e})=>e};
    }
    h3 {
      color: ${({$color:e})=>e};
      font-size: ${({$size:e})=>e};
      line-height: ${({$lineHeight:e})=>e};
      padding: ${({$padding:e})=>e};
      margin: ${({$margin:e})=>e};
    }
    p {
      color: ${({$color:e})=>e};
      font-size: ${({$size:e})=>e};
      line-height: ${({$lineHeight:e})=>e};
      padding: ${({$padding:e})=>e};
      margin: ${({$margin:e})=>e};
    }
    ul {
      margin: 0px 0 0 12px;
      padding: ${({$padding:e})=>e};
      list-style: disc;
      gap:  ${({$gap:e})=>e};
      display: flex;
      flex-direction: column;
    }
    ul li {
      padding: ${({$padding:e})=>e};
      margin: ${({$margin:e})=>e};
      color: ${({$color:e})=>e};
      font-size: ${({$size:e})=>e};
      line-height: ${({$lineHeight:e})=>e};
    }
    a img {
      transition: transform 0.3s ease;
      ${({$expanded:e})=>e&&"transform: rotate(180deg);"}
    }
    ol {
      padding: 0px ${({$gap:e})=>e};
    }
    ol li {
      color: ${({$color:e})=>e};
      font-size: ${({$size:e})=>e};
      line-height: ${({$lineHeight:e})=>e};
    }
`,C=g__default.default.span`
    a img {
      transition: transform 0.3s ease;
      ${({$expanded:e})=>e&&"transform: rotate(180deg);"}
    }
`,k=({content:e,color:t="",lineCount:a=2,isExpandable:s=!1,expandedText:f,collapsedText:c,prefixIcon:m,suffixIcon:x,onViewChange:l,expandVariant:h})=>{let[i,u]=o.useState(!1),{tokens:n}=chunkHUKGHOBJ_js.b(),r=o.useRef(null),b=()=>{i&&r&&r.current&&setTimeout(()=>{r.current.scrollIntoView();},0);let d=!i;u(d),typeof l=="function"&&l(d);};return o__default.default.createElement(o__default.default.Fragment,null,o__default.default.createElement(S,{ref:r,dangerouslySetInnerHTML:{__html:e},$color:t||n.text_default_text_primary,$size:n.font_size_sm,$lineHeight:n.font_line_height_xl,$lineCount:a,$isExpandable:s,$expanded:i,$padding:n.spacing_0,$margin:n.spacing_0,$gap:n.spacing_16,$fontWeight:n.font_weight_semibold,$fontSize:n.font_size_lg}),s&&o__default.default.createElement(C,{$expanded:i},o__default.default.createElement(chunkGWPDT7BR_js.a,{label:i?f:c,onClick:b,underLine:!1,prefixIcon:m,suffixIcon:x,preventDefaultBehaviour:!0,variant:h})))};

exports.CmsContent = k;
